import { render, staticRenderFns } from "./LastProcess.vue?vue&type=template&id=9fbc2f2c&scoped=true"
import script from "./LastProcess.vue?vue&type=script&lang=js"
export * from "./LastProcess.vue?vue&type=script&lang=js"
import style0 from "./LastProcess.vue?vue&type=style&index=0&id=9fbc2f2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fbc2f2c",
  null
  
)

export default component.exports